// 项目没有使用 router
// 这里模拟一个全局的 location.pathname 的 getter setter
import PubSub from 'pubsub-js'
import _debounce from 'lodash/debounce'

const PubSubTopic = 'LOCATION.PATHNAME'

let pathName = '/'

export const getPathName = () => {
    return pathName
}

export const publishPathName = path => {
    PubSub.publish(PubSubTopic, path)
}

export const setPathName = _debounce(
    path => {
        pathName = path
        window.history.pushState(null, null, path)
        PubSub.publish(PubSubTopic, pathName)
    },
    50,
    {
        leading: true,
        trailing: false,
    }
)

export const subscribePathName = callbackFn => {
    return PubSub.subscribe(PubSubTopic, (msg, data) => {
        if (msg === PubSubTopic) {
            callbackFn(data)
        }
    })
}

export const unsubscribePathName = PubSub.unsubscribe
